/***
 * Currently only used for FlashNotes.
 */

var GroupCollection = require('./groupCollection'),
    fvChannel = require('glRadio').channel('FV');


module.exports = GroupCollection.extend({

    url: function() {

        return fvChannel.request('apiUrl').allPrivateGroups;

    },

    /**
     * Filter out null 'description' -- value must be present in dd
     * If use for other purposes, the logic should be moved elsewhere.
     */
    parse: function( resp ) {

        resp = GroupCollection.prototype.parse.apply( this, arguments );

        return _.filter( resp, function( g ) {
            return g.description !== null && g.description !== '';
        });

    },

    /**
     * Fetch or provide cached result -- what is fed to the select box in the note view.
     * Again: logic belongs elsewhere if we ever use for other purposes ....
     * We also don't include the private group of the user -- but:
     *  dds the current user back as the first value (and as 'me').
     */
    getIdDescs: function() {

        if ( this.groupIDNames ) {

            return this.groupIDNames;

        } else {

            /* Note: Also sets the current user as 'me' and sorts atop others */
            var groupOfUser = fvChannel.request('user').getPrivateGroup();

            this.groupIDNames =  this.chain()
                .map( function(g) {
                    return _.pick( g.toJSON(), 'groupId', 'description');
                })
                .reject( function(i) {
                    return i.groupId === groupOfUser.get('groupId');
                })
                .sortBy( function(i) {
                    return i.description.toLowerCase();
                } )
                .unshift(
                     _.chain( groupOfUser.attributes ).pick('groupId', 'description' ).extend( {'description': 'Me'} ).value()
                )
                .value();

            return this.groupIDNames;

        }

    },

    getGroupIds: function() {
        return this.pluck('groupId');
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/user/groups/privateGroups.js
 ** module id = 88
 ** module chunks = 0
 **/